import i18n from 'i18next'
import moment from 'moment'
import 'moment/locale/fr'

i18n.on('languageChanged', (lng) => {
    moment.locale(lng)
})
